import * as React from 'react';
import { PillToggleGroup } from '../../ui/pill-toggle-group';
import { FilterSection } from './FilterSection';
import { CARE_COORDINATION_OPTIONS } from '../constants';
import { RosterFilters } from './types';

/**
 * Where the member sits in the care-coordination funnel.
 *
 * **Single-select** as of round 6. A member occupies exactly one funnel stage,
 * so the multi-select this used to be could only ever express an OR across
 * stages, and the team asked for one stage at a time.
 *
 * It also used to carry a second pill row — a "New (last 7 days)" toggle that
 * ANDed against the funnel selection, because signup recency co-occurs with
 * any stage and unioning it with the funnel values was a real bug (round 2).
 * That toggle has moved to `EnrollmentStatusSection` along with Cancelled, and
 * the intersection it existed to express still works: it's now an AND across
 * two sidebar groups rather than inside one. Pulling it out is precisely what
 * left a single, honestly mutually-exclusive set of values here.
 */
export const CareCoordinationSection = ({
  filters,
}: {
  filters: RosterFilters;
}) => (
  <FilterSection title="Care Coordination">
    <PillToggleGroup
      options={CARE_COORDINATION_OPTIONS}
      selected={filters.careCoordination ? [filters.careCoordination] : []}
      onChange={filters.onCareCoordinationChange}
      multiple={false}
    />
  </FilterSection>
);
